import { Avatar, Box, Grid, MenuItem, Select, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomAuto from "../../components/autocomplete/CustomAuto";
import CompanyQandAModals from "../../components/dialog/CompanyModals";
import { capitalizeWords, DiscoverySearchInfluencerButton, getCompanyFlowStatus, getSearchdata, getUserType, setSearchdata } from "../../utils/common";
import { COMPANY, PLATFORMS_IMGS_LIST } from "../../utils/constant";
import { checkCreditOnDashboard } from "./action";
import { updateDashboard } from "./dashboardSlice";
import arrowTopDiagonal from "../../assets/images/icons/arrowTopDiagnoal.svg"
import { useEffect, useState } from "react";
import NestedDropdown from "./NestedDropdown";
const SearchData = () => {
  const { plateforms, niches, userInfo } = useSelector((state) => state.commonSlice);
  const { filters,limit } = useSelector((state) => state.dashboardSlice)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDropdown, setOpenDropdown] = useState(false);
  useEffect(() => {
    dispatch(
      updateDashboard({
        filters: { platform: "Instagram" },
        search: "",
        list: [],
        totalCount: 0,
        totalPages: 0,
      }),
    );
    setSearchdata(JSON.stringify({ platform: "Instagram", }));
  }, [])


  return <>
    <Formik
      initialValues={{platform: "Instagram", categories: [] }}
      validateOnChange={true}
      onSubmit={(values) => {
        values.categories = values?.categories?.map((v) => v.title);
        const jsonString = JSON.stringify(values);
        setSearchdata(jsonString);
        dispatch(
          updateDashboard({limit:limit || 20,page:1,totalCount:0,list:[],
            filters: { ...filters, ...values}
          }),
        );
        dispatch(checkCreditOnDashboard(navigate))
      }}
    >
      {({
        handleChange,
        handleSubmit,
        values,
      }) => {
        return (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e);
            }}
          >
            <Grid className="campSerchInflu" pt={2} container mb={5}>
              <Grid item className='mx-auto' xs={12} xl={6} lg={8} md={11} sm={12} pt={5} sx={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                <Typography variant="h3" fontWeight="bold" sx={{
                  background: "linear-gradient(90deg, #FFCC70 0%, #C850C0 50%, #4158D0 100%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textAlign: 'center',
                  fontFamily: "var(--family1)",width:'fit-content',paddingBottom:'16px'

                }}>
                  Hey {capitalizeWords((getUserType() === COMPANY ? userInfo?.companyName || userInfo?.contactPersonName : userInfo?.adminName))}
                </Typography>
                <Typography sx={{
                  textAlign: 'center',fontWeight:400,fontSize:'20px',
                  fontFamily: "var(--family1)", color: '#726C6C'
                }}>
                  Let Us Help You Find the Right Influencers—Effortlessly!
                </Typography>
                <Grid className="mx-auto" item xs={12} xl={12} lg={12} md={12} sm={12} style={{width:'100%'}}>
                  <Box className="searchBlockInflu">
                    <Stack direction="row" sx={{padding:'0',justifyContent:'space-between'}}>
                        <Select
                          className="searchPlatform"
                          name="platform"
                          value={values.platform}
                          onChange={handleChange}
                          displayEmpty
                          open={openDropdown}
                          onOpen={() => setOpenDropdown(true)}
                          onClose={() => setOpenDropdown(false)}
                          IconComponent={(props) => <CustomDropdownIcon {...props} open={openDropdown} />}
                          sx={{
                            minWidth: "fit-content",
                            borderRadius: "8px",
                            background: "white",
                            position: "relative",
                            overflow: "hidden",
                            height: '40px',
                            "& .MuiSelect-select": {
                              padding: '0 0px 0 13px !important',
                              width:'68px'
                          },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",border:'0px solid transparent'
                            },
                            "::before": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              padding: "2px",
                              borderRadius: "8px",
                              background: "linear-gradient(90deg, #FFCC70, #C850C0, #4158D0)",
                              "-webkit-mask":
                                "linear-gradient(white, white) content-box, linear-gradient(white, white)",
                              "-webkit-mask-composite": "destination-out",
                              maskComposite: "exclude",
                              pointerEvents: 'none',
                              outline: 0,
                            }, "&.Mui-focused, &:hover, &:focus-within,&:focus-visible": {
                              border:'0px solid transparent',
                              "::before": {
                                opacity: 1,
                              },
                            },
                            padding: '0px',
                            outline: 0,
                          }}
                          renderValue={(selected) => (
                            selected ? (
                              <img
                                alt={selected}
                                width="24" height="24"
                                src={PLATFORMS_IMGS_LIST[selected]}
                              />

                            ) : "Select Platform"
                          )}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                height:'85px',
                                width:'130px',
                                padding:'0px !important',
                                borderRadius: "12px",
                                boxShadow: '0px 4px 12px 0px #0000001F',

                                mt: 1,
                                "& .MuiMenuItem-root": {
                                  color: "black",
                                },
                              },
                            },
                          }}
                        >
                          {plateforms.map((item) => (
                            <MenuItem
                              key={item}
                              value={item}
                              sx={{ display: "flex", alignItems: "center", gap: 1, padding: "4px 8px", }}
                            >
                              <Avatar
                                alt={item}
                                src={PLATFORMS_IMGS_LIST[item]}
                                sx={{ width: 24, height: 24,overflow:'visible' }}
                              />
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      <Box className="searchText" style={{ width: 'calc(100% - 150px)', paddingLeft: '20px', fontSize: '15px' }}>
                        <CustomAuto type="dashboard" handleChange={(e, newValue) => {
                          handleChange({
                            target: { name: "categories", value: newValue },
                          });
                        }} values={values} />
                      </Box>
                      <Box
                        sx={{
                          zIndex: 999,
                          display: 'inline-flex', width: '120px', justifyContent: 'flex-end',
                        }}
                      >
                       <DiscoverySearchInfluencerButton/>
                      </Box>


                    </Stack>
                    <div className="search-parent-second">
                      <NestedDropdown parentFormValues={values} parentFormHandleChange={handleChange}/>
                    </div>
                  </Box>
                  <Stack>
                  </Stack>
                <Box sx={{ height: '100vh', marginTop: '60px' }}>
                  <Stack>
                    <ul className="search-suggestion-list">
                      <li className="search-suggestion-item">
                        <Typography className="search-suggestion-text">List of 10 Travel Influencers 🎒</Typography>
                        <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                      </li>
                      <li className="search-suggestion-item">
                        <Typography className="search-suggestion-text">Top Food Instagrammers in Delhi 🍝</Typography>
                        <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                      </li>
                    </ul>

                    <ul className="search-suggestion-list">
                      <li className="search-suggestion-item">
                        <Typography className="search-suggestion-text">Food influencers with fitness followers 💪</Typography>
                        <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                      </li>
                      <li className="search-suggestion-item">
                        <Typography className="search-suggestion-text">Top Finance and Business Youtubers 💰</Typography>
                        <img src={arrowTopDiagonal} alt="arrowTopDiagonal" className="search-suggestion-icon" />
                      </li>
                    </ul>

                  </Stack>
                </Box>
                </Grid>

              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
    {getUserType() === COMPANY && getCompanyFlowStatus() == 1 && <CompanyQandAModals />}
  </>
}
export default SearchData;
const CustomDropdownIcon = ({open,...props}) => {
  return(
    <div {...props} style={{padding:'0',marginRight:'10px'}}>
  <svg style={{
    transition: "transform 0.3s ease",
    border:'0px solid red',padding:'0',margin:'0',height:'14px',width:'14px',
    transform: open ? "rotate(0deg)" : "rotate(180deg)",
  }} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 6L6 1" stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 1L1 6" stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
)};